const adminPageVenueRelationshipsSectionCopy = {
  menuItemLabelExchanges: 'Exchanges',
  menuItemLabelOtc: 'OTC',
  sectionTitle: 'Supported Trading Venues'
};

export default adminPageVenueRelationshipsSectionCopy;
